import React, { useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Skeleton } from "primereact/skeleton";
import { Avatar } from "primereact/avatar";
import { format } from "date-fns";
import { useSelector } from "react-redux";

import EmptyDataView from "~/components/nodataview";
import FileIcon from "~/components/file-type-icon";
import { downloadFileHandler } from "~/utils/fileUtils";
import fileIcon from "../../../../assets/images/file-icon.png";
import DocumentDescription from "~/components/document-description";
import { useParams } from "react-router-dom";

const RequestAttachmentTable = ({
  attachment,
  loading,
  rows,
  onPageChange,
  isDataAvailable,
  first,
  handleAttachmentDelete,
}) => {
  const { id: userId, role } = useSelector((state) => state.login);
  const { id } = useParams();
  const skeletonRows = [...Array(5)];
  const getInitials = (fullName) => {
    const nameArray = fullName.split(" ");
    const firstInitial = nameArray[0]?.charAt(0) || "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} Bytes`;
    if (bytes < 1048576) return `${Math.floor(bytes / 1024)} KB`;
    return `${Math.floor(bytes / 1048576)} MB`;
  };

  return (
    <div className="attachment__table--container">
      {isDataAvailable ? (
        <DataTable
          tableStyle={{ minWidth: "70rem" }}
          value={loading ? skeletonRows : attachment}
          className="datatable-right-align"
          paginator={attachment?.length > 10}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          rowsPerPageOptions={[10, 20, 30]}
          emptyMessage="No results were found"
          first={first}
          rows={rows}
          onPage={onPageChange}
        >
          <Column
            header="Name"
            className="col__file"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <span className="file__name">
                  <FileIcon filetype={data?.file_type} filename={data?.name} />
                </span>
              )
            }
          />
          <Column
            header="Uploaded by"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <div className="flex align-items-center gap-1">
                  <Avatar
                    shape="circle"
                    label={getInitials(
                      [
                        data?.createdByData?.first_name,
                        data?.createdByData?.last_name,
                      ]
                        .filter(Boolean)
                        .join(" "),
                    )}
                  />
                  <span>
                    {data?.createdByData?.first_name}{" "}
                    {data?.createdByData?.last_name}{" "}
                  </span>
                </div>
              )
            }
          />
          <Column
            header="Creation Date"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                format(data.createdAt, "MMMM dd, yyyy")
              )
            }
          />
          <Column
            header="File Size"
            body={(data) =>
              loading ? <Skeleton width="100%" /> : formatFileSize(data?.size)
            }
          />
          <Column
            className="user_action--col"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <div className="flex justify-content-center align-items-center">
                  <DocumentDescription data={data} id={id} type="REQUEST" />
                  <span
                    className="pi pi-download pencil-pointer"
                    onClick={() =>
                      downloadFileHandler({
                        blob_url: data?.blob_url,
                        name: data?.name,
                      })
                    }
                  ></span>
                  {(role === "GXM_ADMIN" || data.created_by === userId) && (
                    <span
                      className="pi pi-trash pencil-pointer"
                      onClick={() => handleAttachmentDelete(data)}
                    ></span>
                  )}
                </div>
              )
            }
          />
        </DataTable>
      ) : (
        <div className="flex flex-column justify-content-center align-items-center p-5 empty__dataview">
          <EmptyDataView
            Icon={
              <img
                className="users-card-icon-img"
                src={fileIcon}
                alt="File Icon"
              />
            }
            Header="No files here yet"
            Description="Start uploading files, or wait for others to do so."
          />
        </div>
      )}
    </div>
  );
};

export default RequestAttachmentTable;
